import { getUserDetails } from "../../DoctorMangement/Helper/utils";
import { FORM_NAMES_KEY, INCLINIC, OFFLINE } from "../constant";
import { getRoles } from "./API";
import { ToastEmitter } from "../../DoctorMangement/ToastEmitter";
import {  getUserDetailsFromAccessToken } from "../../../helper/utils"
export const getUrlForSPOCProfilePage = (id, userName=null) => {
    return `/SPOC/SPOCManagements?id=${id}&userName=${encodeURIComponent(userName)}`;
  }


  export const getEntityList = () => {
    const userDetails = getUserDetails()
    let entityArray = [];
    if (userDetails?.parentProvider?.isParent) {
      let childEntity = userDetails.parentProvider.childEntitiesWithEntityId
      const locationsArray = Object.values(childEntity).map(location => location.split(",")[0].trim());
      const masterEntityName = userDetails?.entityName + ' (Master Provider)';
      entityArray = [masterEntityName, ...locationsArray];
    }
    else {
      entityArray = [userDetails?.entityName];
    }
    return entityArray
  }

  export const getEntityNameMapping = () => {
    const userDetails = getUserDetails()
    const mapping = {};
  
    if (userDetails.parentProvider.isParent) {
      let childEntity = userDetails.parentProvider.childEntitiesWithEntityId
      for (const [id, fullName] of Object.entries(childEntity)) {
        const locationName = fullName.split(",")[0].trim();
        mapping[locationName] = id;
        const masterEntityName = userDetails?.entityName + ' (Master Provider)';
        mapping[masterEntityName] = userDetails?.entityId;
      }
    }
    else {
      mapping[userDetails.entityName] = userDetails.entityId;
    }
    return mapping
  }


  export const getEntityIdMapping = () => {
    const userDetails = getUserDetails()
    const mapping = {};
  
    if (userDetails.parentProvider.isParent) {
      let childEntity = userDetails.parentProvider.childEntitiesWithEntityId
      for (const [id, fullName] of Object.entries(childEntity)) {
        const entityName = fullName.split(",")[0].trim();
        const masterEntityName = userDetails?.entityName + ' (Master Provider)';
        mapping[userDetails?.entityId] = masterEntityName;
        mapping[id] = entityName;
      }
    }
    else {
      mapping[  userDetails.entityId] =userDetails.entityName;
    }
    return mapping
  }


  const getRolesForSPOC = async () => {
    const SPOCRolesArray = await getRoles();
    const rolesArray = SPOCRolesArray?.roles?.map((role) => {
        return {
          id: role.id,
          RoleName: role.name,

        }
    })
    if(rolesArray.length > 0) return rolesArray
    else return null;
  }


  const formatRoleNameAndLabel = (role)=>{
    let roleName ='';
    let roleLabel =''
    const roleNameSplit = role.RoleName.split("/*/");
    if(!(roleNameSplit.length>1)) return {roleName, roleLabel};
    const roleDeptLabel = roleNameSplit[0].split('/');
    if(!(roleDeptLabel.length>1)) return {roleName:roleNameSplit[1], roleLabel: roleNameSplit[0].replaceAll('_', ' ')}; 
     roleName = roleNameSplit[1];
     roleLabel = roleDeptLabel[1].replaceAll('_', ' ');
    return {roleName, roleLabel};
  }

  export const rolesArray = async ()=>{
    try {
      const resp = await getRolesForSPOC()

      const rolesMapAdmin = {};
      const rolesMapEditor ={};
      const rolesMapViewer = {};
      const rolesMapServices = {};
  
      //admin roles
      const adminRolesArray = resp?.map((role) => {
        const {roleName, roleLabel} = formatRoleNameAndLabel(role);
        if(roleName.toLowerCase() == 'admin'){
          return rolesMapAdmin[roleLabel]=role.id;
        }
      }).filter((role) => role != undefined);
  
      //editor roles
      const editorRolesArray = resp?.map((role) => {
        const {roleName, roleLabel} = formatRoleNameAndLabel(role);
        if(roleName.toLowerCase() == 'editor'){
          return rolesMapEditor[roleLabel]=role.id;
        }
      }).filter((role) => role != undefined);
  
      //viewer roles
      const viewerRolesArray = resp?.map((role) => {
        const {roleName, roleLabel} = formatRoleNameAndLabel(role);
        if(roleName.toLowerCase() == 'viewer'){
          return rolesMapViewer[roleLabel]=role.id;
  
             }
      }).filter((role) => role != undefined);
  
      const servicesRolesArray = resp?.map((role) => {
        const {roleName, roleLabel} = formatRoleNameAndLabel(role);
        if(roleName.toLowerCase() == 'services'){
          return rolesMapServices[roleLabel]=role.id;
        }
      }).filter((role) => role != undefined);
  
      return { "admin":rolesMapAdmin, "editor":rolesMapEditor, "viewer":rolesMapViewer, 'services':rolesMapServices}
    }

    catch (error) {
      console.log("Error in the function rolesArray", error);
      throw error;
    }

  }


export const getRolesIdForSelectedRoles = async (formValues) => {
  try {

    //for OFC speciality 
    const selectedOFCSpeciality = formValues?.OFCspecicality?.map((item) => {
      return item?.value
    })

    //for Labs Specicality
    const selectedLabsSpecicality = formValues?.labsSpecicality?.map((item) => {
      return item.value;
    })

    //for services Lab and OFC
    const selectedServices = [];
    if (formValues[FORM_NAMES_KEY.LABS_ACTIVE]) {
      selectedServices.push(FORM_NAMES_KEY.LABS_SERVICE);
    }

    if (formValues[FORM_NAMES_KEY.OPD_ACTIVE]) {
      selectedServices.push(FORM_NAMES_KEY.OPD_SERVICE);
    }


    const roles = await rolesArray();
    const accessLevel = formValues.accessLevel;
    const userRoles = [];

    //for Offline Consults Roles
    for (let index in selectedOFCSpeciality) {
      const speciality = selectedOFCSpeciality[index];
      const accessRoles = roles[accessLevel];
      const accessSpeciality = accessRoles[speciality];
      if (accessSpeciality)
        userRoles.push(accessSpeciality)
    }

    //for Labs Departments
    for (let index in selectedLabsSpecicality) {
      const department = selectedLabsSpecicality[index];
      const accessRole = roles[accessLevel];
      const accessDepartment = accessRole[department];
      if (accessDepartment) {
        userRoles.push(accessDepartment);
      }
    }

    //for Services
    for (let index in selectedServices) {
      const service = selectedServices[index];
      const servicesRole = roles.services
      const accessRole = servicesRole[service];
      if (accessRole) {
        userRoles.push(accessRole);
      }
    }

    return userRoles
  }
  catch (err) {
    console.log("Error in function in getRolesIdForSelectedRoles", err);
    ToastEmitter("Unable to get roles for SPOC", 'error');
    throw err;
  }
}

export const getFeaturesForUser = async (history) => {
  const userDetailsResp = await getUserDetailsFromAccessToken();
  if (userDetailsResp) {
    const userFeature = userDetailsResp?.features?.map((item) => {
      return item.featureName;
    })
    const userRoles = userDetailsResp?.roles
    return {userFeature,userRoles };
  }
  localStorage.clear();
  history.push("/login");
  return [];
}


export const getServiceFilter  = (serviceFilterArray) => {
  const activeServicesFilter = serviceFilterArray.map((val) => {
    if (val == INCLINIC) return OFFLINE;
    else return val; });
    return activeServicesFilter
}

  